import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LayoutComponent } from './layout.component';
import { MaterialModule } from '../../material.module';
import { LayoutRoutingModule } from './layout-routing.module';
import { BreadcrumbsModule } from '../breadcrumbs/breadcrumbs.module';
import { LoginComponent } from '../../components/auth/login/login.component';
import { RoleService } from '../../services/role.service';

import { ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NotificationComponent } from './components/notifications/notification/notification.component';
import { LoadingComponent } from '../../components/loading/loading.component';

@NgModule({
	declarations: [
		LayoutComponent,
		LoginComponent,
		ConfirmDialogComponent,
		NotificationsComponent,
		NotificationComponent,
		LoadingComponent
	],
	imports: [
		CommonModule,
		MaterialModule,
		LayoutRoutingModule,
		BreadcrumbsModule
	],
	exports: [
		LayoutComponent,
		ConfirmDialogComponent
	],
	providers: [
		RoleService
	]
})
export class LayoutModule { }
